import React, { createContext, ReactNode, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useProject } from './useProject';

interface ValidationContextType {
  isValidationVisible: boolean;
  showValidation: () => void;
}

const ValidationContext = createContext<ValidationContextType | undefined>(
  undefined,
);

interface ValidationProviderProps {
  children: ReactNode;
}

export const ValidationProvider: React.FC<ValidationProviderProps> = ({
  children,
}) => {
  const { projectId } = useParams();
  const { project } = useProject(projectId);
  const [isValidationVisible, setIsValidationVisible] =
    useState<boolean>(false);

  const hasRequiredFields = project?.model?.hasRequiredFields;

  const showValidation = () => {
    if (!hasRequiredFields) return;
    setIsValidationVisible(true);
  };

  return (
    <ValidationContext.Provider value={{ isValidationVisible, showValidation }}>
      {children}
    </ValidationContext.Provider>
  );
};

export const useValidationContext = (): ValidationContextType => {
  const context = useContext(ValidationContext);
  if (!context) {
    throw new Error(
      'useValidationContext must be used within a ValidationProvider',
    );
  }
  return context;
};
